var _Path, _Path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgForgotPassword(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M14.758 35.617H6.022a3.494 3.494 0 01-3.495-3.494V7.66a3.495 3.495 0 013.495-3.495h27.956a3.495 3.495 0 013.495 3.495v10.483",
    stroke: "#fff",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M20 35.618v-8.105c0-.89.175-1.745.497-2.54m16.976 10.645v-5.564m-13.59-8.878c1.388-.81 3.057-1.283 4.854-1.283 3.982 0 7.343 2.325 8.395 5.504M25.242 37.366v-3.803m6.99 3.803v-8.994c0-1.788-1.566-3.237-3.495-3.237-1.93 0-3.495 1.45-3.495 3.237v1.388M2.527 11.156h34.946M7.769 7.674l.015-.016M13.01 7.674l.015-.016M18.253 7.674l.014-.016",
    stroke: "#fff",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgForgotPassword;